import { BaseLayout } from '@components/Layout';
import {
  ExperiencePage as ExperiencePageComponent,
  getExperienceById,
  getExperiences,
  getImageKitUrl,
} from '@milo/react';
import { Experience } from '@milo/types';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';

export const getStaticPaths: GetStaticPaths = async () => {
  const expList = await getExperiences();
  const paths = expList.map((e: Experience) => {
    return { params: { slug: e.slug as string } };
  });

  return {
    paths: paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const params = context?.params;
    const slug = params?.slug as string;
    const id = Number(slug.split('-').slice(-1)[0]);
    const experience = await getExperienceById(id);

    if (!experience?.id) {
      return { notFound: true };
    }

    return {
      props: {
        experience,
        seo: {
          title: experience.name,
          description: experience.description,
          imagePath: experience.main_image
            ? getImageKitUrl(experience.main_image, 'w-1200,h-630,c-maintain_ratio')
            : null,
        },
      },
      revalidate: 30,
    };
  } catch (e) {
    console.log('Error', e);
    return { notFound: true };
  }
};

type ExperiencePageProps = {
  experience: Experience;
};

const ExperiencePage: NextPage<ExperiencePageProps> = (props) => {
  const experience = props?.experience;

  return (
    <BaseLayout stickyNavigation showFooter={false}>
      <ExperiencePageComponent experience={experience} />
    </BaseLayout>
  );
};

export default ExperiencePage;
